import { Text } from '@viapeople/components'
import { Fragment } from 'react'

interface WizardStep {
	id: string
	label: string
}

interface WizardStepIndicatorProps {
	steps: WizardStep[]
	activeStep: number
}

export function WizardStepIndicator({ steps, activeStep }: WizardStepIndicatorProps) {
	return (
		<div className='flex items-start w-full px-4 py-6'>
			{steps.map((step, index) => {
				const isCompleted = index < activeStep
				const isActive = index === activeStep
				const isUpcoming = index > activeStep

				return (
					<Fragment key={step.id}>
						{/* Step column — shrink-0 so labels never push connectors */}
						<div className='flex flex-col items-center shrink-0 w-16'>
							<div
								className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold transition-colors ${
									isCompleted
										? 'bg-primary-600 text-white'
										: isActive
											? 'bg-primary-600 text-white ring-4 ring-primary-100'
											: 'bg-neutral-200 text-neutral-500'
								}`}>
								{isCompleted ? (
									<svg className='w-4 h-4' fill='none' viewBox='0 0 24 24' stroke='currentColor' aria-hidden='true'>
										<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2.5} d='M5 13l4 4L19 7' />
									</svg>
								) : (
									index + 1
								)}
							</div>
							<Text
								variant='xsmall'
								weight={isActive ? 'semibold' : 'regular'}
								className={`mt-2 text-center leading-tight ${isUpcoming ? 'text-neutral-400' : 'text-neutral-700'}`}>
								{step.label}
							</Text>
						</div>

						{/* Connector — flex-1 fills whatever space remains between circles */}
						{index < steps.length - 1 && (
							<div
								className={`flex-1 h-0.5 mt-4 transition-colors ${
									index < activeStep ? 'bg-primary-600' : 'bg-neutral-200'
								}`}
							/>
						)}
					</Fragment>
				)
			})}
		</div>
	)
}
